import React, { ReactNode, useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { getData } from "../apis";
import { API } from "../apis/config";

export enum EventType {
  OPENING_WAREHOUSE = 1,
  FESTA,
  PAJUSPIEL,
}
export const queryId = "c";

interface QueryValidationProps {
  type: EventType;
  children: ReactNode;
}

const checkQueryString = async (
  queryValue: string | null,
  type: EventType
): Promise<boolean> => {
  try {
    var response = await getData<string>(API.UTILS.URL_VALIDATION, {
      params: { type },
    });
    return response.result === queryValue; // DB 검증 결과 (true/false)
  } catch (error) {
    console.error("url verification failed:", error);
    return false;
  }
};

const UrlValidation: React.FC<QueryValidationProps> = ({ children, type }) => {
  const location = useLocation();
  const queryValue = new URLSearchParams(location.search).get(queryId); // 쿼리스트링 추출
  const [isValid, setIsValid] = useState<boolean | null>(null);

  useEffect(() => {
    const validateQuery = async () => {
      if (queryValue) {
        const valid = await checkQueryString(queryValue, type);
        setIsValid(valid);
      } else {
        setIsValid(false); // 쿼리스트링이 없으면 유효하지 않다고 처리
      }
    };
    validateQuery();
  }, [queryValue, type]);

  if (isValid == null) {
    return <></>;
  } else if (isValid === false) {
    return <Navigate to="/error" />; // 유효하지 않으면 오류 페이지로 리디렉션
  } else return <>{children}</>; // 유효하면 자식 컴포넌트 렌더링
};

export default UrlValidation;
